import { makeStyles } from "@material-ui/styles";

export default makeStyles(() => ({
  confTextarea: {
    width: "80%",
  },
}));
